exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".totalCell-a2801{display:flex;justify-content:flex-end}", ""]);

// Exports
exports.locals = {
	"totalCell": "totalCell-a2801"
};